<template>
  <v-dialog v-model="dialogOpen" max-width="500">
    <v-card>
      <v-card-title class="modal-title">
        {{ isEditing ? "Edit Goal" : "New Goal" }}
      </v-card-title>

      <v-card-text class="pt-6">
        <v-textarea
          ref="descriptionInput"
          v-model="formData.description"
          label="Description"
          placeholder="Enter goal description"
          outlined
          autofocus
        ></v-textarea>
        <div v-if="warning" class="warning-message">
          {{ warning }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveGoal">
          <v-icon v-if="isEditing" left>mdi-content-save</v-icon>
          <v-icon v-else left>mdi-plus</v-icon>
          Save
        </v-btn>
        <v-btn @click="closeModal"> Cancel </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import apiClient from "@/plugins/apiService";

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    selectedProblem: {
      type: [String, Number],
      required: true,
    },
    editingGoal: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        description: "",
      },
      warning: null,
    };
  },
  computed: {
    isEditing() {
      return this.editingGoal !== null;
    },
    dialogOpen: {
      get() {
        return this.isOpen;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  watch: {
    isOpen(newVal) {
      if (newVal && this.editingGoal) {
        this.formData.description = this.editingGoal.description;
      } else if (newVal) {
        this.formData.description = "";
        // Focus the textarea for new goals
        this.$nextTick(() => {
          if (this.$refs.descriptionInput) {
            this.$refs.descriptionInput.focus();
          }
        });
      }
    },
  },
  methods: {
    saveGoal() {
      if (!this.formData.description.trim()) {
        this.warning = "Description cannot be empty.";
        return;
      }

      if (this.isEditing) {
        apiClient
          .put(`/goal/${this.editingGoal.id}`, this.formData)
          .then((response) => {
            if (response.status === 200) {
              this.$emit("goal-saved");
              this.closeModal();
            }
          });
      } else {
        const newGoal = {
          description: this.formData.description,
          problem_id: this.selectedProblem,
        };
        apiClient.post(`/goal`, newGoal).then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$emit("goal-saved");
            this.closeModal();
          }
        });
      }
    },
    closeModal() {
      this.formData.description = "";
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-title {
  background-color: var(--primaryColor);
  color: white !important;
}
.warning-message {
  color: rgb(224, 127, 0);
  font-size: 0.8em;
}
</style>
